exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kal_table:nth-child(even) {\r\n    clear: left;\r\n}\r\n\r\n.kalender table th.actions, .kalender table td.actions {\r\n    width: 40px;\r\n}\r\n\r\n.kal_table th:nth-child(0n+2){\r\n    width: 22%;\r\n}\r\n.kal_table th:nth-child(0n+3){\r\n    width:12%;\r\n}\r\n\r\n.next_event .actions > a{\r\n    color: #f0f0f0;\r\n\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/activiteiten.css
// module id = 46
// module chunks = 0